// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "bundles/" + __webpack_require__.h() + "/" + {"1869":"styles","5607":"error-view","6145":"compatibility-view"}[chunkId] + ".css";
};